import { serverAddr } from "../networkConfig";
import axios from 'axios';
export default {
	forecastQuery(queryObject, pageInfo) {
		console.log("pageInfo", pageInfo, queryObject);
		return serverAddr.post(
			`/forecast/query/?page=${pageInfo.currentPage}&page_size=${
				pageInfo.pageSize
			}`,
			queryObject
		);
	},
	forecastAll(queryObject, pageInfo) {
		return serverAddr.post(
			`/forecast/query/?get_all=true`,
			queryObject
		);
	},
	mapIds(queryObject) {
		return serverAddr.post("/common/name-mapping/", queryObject);
	},
	forecastQueryDetail(queryDetailObject) {
		return serverAddr.post("/forecast/query/detail/", queryDetailObject);
	},
	forecastQueryTrend(queryDetailObject) {
		return serverAddr.post("/forecast/query/trend/", queryDetailObject);
	},
	approveForecast(queryObject) {
		return serverAddr.post("/forecast/approve/", queryObject);
	},
	getAllForecast(queryParams) {
		return serverAddr.post("/forecast/query/?get_all=true", queryParams);
	},
	allForecastQueryDetail(payload){
		return axios.all([
			this.forecastQueryDetail(payload.forecast),
			this.forecastQueryDetail(payload.week),
			this.forecastQueryDetail(payload.year),
			this.forecastQueryTrend({date:payload.forecast.date, outlet:payload.forecast.outlet})
		]);
	},
	approveChangedForecast(payload) {
		return serverAddr.post("/forecast/modify-and-approve-product-forecast/", payload);
	},
	getOutlets() {
		return serverAddr.get("outlet/?get_all=true");
	},
	getEvents(params) {
		return serverAddr.get(
			`/event/?get_all=${params.get_all}&from_date=${
				params.from_date
			}&to_date=${params.to_date}&outlet=${params.outlet}`
		);
	},
	getStoreEvents(params) {
		return serverAddr.post(`/event/list/?get_all=${true}`, params);
	},
	getWeatherInfoNetworkCallBack(params) {
		return serverAddr.get(
			`/weather/?from_date=${params.from_date}&to_date=${
				params.to_date
			}&outlet=${params.outlet}`
		);
	},
	getHourlyForecastDetails(payload){
		return axios.all([
			this.getStoreEvents(payload.event),
			this.getWeatherInfoNetworkCallBack(payload.weather),
			this.getPlaningData(payload.planing),
			// this.getPlaningEfficiency(payload.planing),
		]);
	},
	getPlaningData(payload) {
		return serverAddr.post(`/planning/query/`, payload);
	},
	getPlaningEfficiency(payload) {
		return serverAddr.post(`/planning/get-planning-efficiency/?get_all=true`, payload);
	},
	getEventCategory() {
		return serverAddr.get(`/event_category/?get_all=true`);
	},
	getSummaryData(data) {
		return serverAddr.post("/sheduling/partner/summary_new/", data);
	},
	getForecastLastUpdateDate(data) {
		return serverAddr.post("/planning/last-sales-update/", data);
	},
	getOrderType() {
		return serverAddr.get(`/planning/get-order-types`);
	},
};
